import React from 'react';
import {Snackbar} from "material-ui";
import {connect} from "react-redux";
import {snackMessageHide} from "../../redux/actions/snack_message";

export class Message extends React.Component {

    render() {

        const {message, isShow, snackMessageHide} = this.props;

        return (
            <Snackbar
                anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 'left',
                }}
                open={isShow}
                onClose={snackMessageHide}
                autoHideDuration={3000}
                message={<span id="message-id">{message}</span>}
            />
        )
    }
}

Message = connect(
    (state) => {
        return {
            message: state.snack_message.message,
            isShow: state.snack_message.isShow,
        }
    },
    (dispatch) => {
        return {
            snackMessageHide: () => {
                dispatch(snackMessageHide());
            }
        }
    }
)(Message);


// WEBPACK FOOTER //
// ./src/components/message/index.js